import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/site";

export const Overline = ({ children, className = "", dark = false }) => (
  <p className={`text-[11px] uppercase tracking-[0.32em] font-semibold ${dark ? "text-brand-gold" : "text-brand-rose"} ${className}`}>
    {children}
  </p>
);

const base =
  "inline-flex items-center justify-center gap-2 rounded-full text-sm tracking-wide font-medium transition-transform duration-300 hover:-translate-y-0.5 active:translate-y-0";

export const PrimaryButton = ({ as = "button", to, className = "", children, ...rest }) => {
  const cls = `${base} btn-fill bg-brand-ink text-brand-cream px-8 py-3.5 ${className}`;
  if (as === "link") return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (as === "a") return <a to={to} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const GoldButton = ({ as = "button", to, className = "", children, ...rest }) => {
  const cls = `${base} bg-brand-gold text-brand-ink px-8 py-3.5 hover:bg-brand-ink hover:text-brand-cream ${className}`;
  if (as === "link") return <Link to={to} className={cls} {...rest}>{children}</Link>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const OutlineButton = ({ as = "button", to, className = "", children, ...rest }) => {
  const cls = `${base} border border-brand-ink/25 text-brand-ink px-8 py-3.5 hover:border-brand-ink hover:bg-brand-ink hover:text-brand-cream ${className}`;
  if (as === "link") return <Link to={to} className={cls} {...rest}>{children}</Link>;
  return <button className={cls} {...rest}>{children}</button>;
};

export const NewsletterForm = ({ dark = false, testId = "newsletter-form", source = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email, source });
      toast.success("You're on the list — welcome to Nervani Beauty.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={testId} className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
      <input
        data-testid="newsletter-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className={`flex-1 rounded-full px-5 py-3.5 text-sm outline-none transition-colors ${
          dark
            ? "bg-white/10 text-brand-cream placeholder:text-brand-cream/50 border border-white/15 focus:border-brand-gold"
            : "bg-white text-brand-ink placeholder:text-brand-ink/40 border border-brand-ink/15 focus:border-brand-gold"
        }`}
      />
      <button
        data-testid="newsletter-submit-btn"
        disabled={loading}
        className="btn-fill bg-brand-gold text-brand-ink rounded-full px-7 py-3.5 text-sm font-medium tracking-wide disabled:opacity-60"
      >
        {loading ? "Joining..." : "Join"}
      </button>
    </form>
  );
};
